"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mioglia": {
    "5ecfa934": [{
      "hkey": "2e084718",
      "slug": "mioglia",
      "name": "Mioglia",
      "primary": true,
      "skipSearch": false
    }],
    "carpenaro": [{
      "hkey": "2e084718",
      "slug": "mioglia",
      "name": "Mioglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f710a14": [{
      "hkey": "a36dcdc3",
      "slug": "casone",
      "name": "Casone",
      "primary": true,
      "skipSearch": false
    }],
    "nuclei-casone": [{
      "hkey": "a36dcdc3",
      "slug": "casone",
      "name": "Casone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "744c4606": [{
      "hkey": "2e084718",
      "slug": "mioglia",
      "name": "Mioglia",
      "primary": true,
      "skipSearch": false
    }],
    "schegli": [{
      "hkey": "2e084718",
      "slug": "mioglia",
      "name": "Mioglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;